<script setup>
import { useI18n } from 'vue-i18n';
import BranchNodeBase from './BranchNodeBase.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <BranchNodeBase
    :id="props.id"
    :data="data"
    :selected="selected"
    icon="i-lucide-signpost"
    :type-label="t('SOPS.NODES.ROUTE')"
    accent-class="bg-n-blue-9/15 text-n-blue-11"
  />
</template>
